module.exports = __webpack_public_path__ + "img/atelier-coline-squared.78fd557.jpg";